import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * DP276-M4 — the label stocks a firm can buy, and the one it buys.
 *
 * The list is product names, not a design choice: what the printer takes. The
 * firm's default is remembered in company settings so receiving does not pick
 * the stock again every time a carton lands.
 */
// MT-2 — the four the label lays out for, by what the printer takes.
export const LABEL_STOCKS = [
  ['ql62', '62 mm tape'],
  ['ql29', '29 mm tape'],
  ['l46', '4 × 6'],
  ['p1l', '50 × 80'],
];

export const useLabelStock = (preferred = '') => {
  const [stock, setStock] = useState(preferred || 'ql62');
  const [firmDefault, setFirmDefault] = useState('ql62');

  useEffect(() => {
    axios.get(`${API}/company-settings`)
      .then((r) => {
        const remembered = r.data?.label_stock || r.data?.label_stock_default || 'ql62';
        setFirmDefault(remembered);
        // MT-2 — a reprint keeps the stock the tag was printed on.
        if (!preferred) setStock(remembered);
      })
      .catch(() => { /* the film is the default default */ });
  }, [preferred]);

  // MT-2 — the last stock printed is this firm's stock, without being asked.
  const remember = async (chosen) => {
    const keep = chosen || stock;
    if (keep === firmDefault) return;
    try {
      await axios.put(`${API}/company-settings`, { label_stock: keep });
      setFirmDefault(keep);
    } catch { /* the print matters more than the memory */ }
  };

  const makeDefault = async () => {
    try {
      await axios.put(`${API}/company-settings`, { label_stock: stock });
      setFirmDefault(stock);
      toast.success('Saved as this firm’s label stock');
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Could not remember that stock');
    }
  };

  return { stock, setStock, firmDefault, makeDefault, remember };
};

export default useLabelStock;
